import React, { useEffect, useCallback, useState} from 'react';
import {moveEdgeInlet} from 'components/messaging/moveEdge.js';
import {connect} from 'react-redux';

const InletField = ({children, object, inlet, movingEdge, drawingEdge}) => { 
    const connect = useCallback(() => {
       if (drawingEdge && drawingEdge.type) {
            // otherwise connect them
            object.connectInlet(inlet, drawingEdge.node, drawingEdge.type); 
        } else if (movingEdge) {
            moveEdgeInlet(object, inlet, movingEdge);
        }
    }, [object, inlet, drawingEdge, movingEdge]);

    return (
        <div className="inlet-field">
          <div
            className={object.isInletConnected(inlet) ? "inlet connected" : "inlet"}
            id={object.getFullType(inlet)}
            onMouseUp={connect}
          >
        </div>
            {children}
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
      drawingEdge: props.object && props.object.subSequence && state.pads.drawingEdges[props.object.subSequence.id],
      movingEdge: state.pads.movingEdge
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InletField);
